import {
	GLOBAL_COLOR_TYPOGRAPHY_COPY_DEFAULT_LIGHT,
	SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_DISABLED_LIGHT,
	SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_INTERACTIVE_LIGHT,
	SEM_COLOR_FORMS_SURFACE_CONTROL_STROKE_DEFAULT_LIGHT,
	SYS_SPACE_RELATIVE_BP_MD_MD,
	SYS_SPACE_RELATIVE_BP_SM_SM,
	SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL,
} from '@oneaudi/unified-web-common';

import styled from 'styled-components';
import { zIndexTop } from '~/styles/tokens';

export const CollapsibleBoxStyle = styled.div`
	display: grid;
	grid-template-rows: 1fr;
	transition: grid-template-rows 0.6s ease;

	.inner-container {
		opacity: 1;
		transition: opacity 0.4s ease;
		overflow: hidden;
		color: ${GLOBAL_COLOR_TYPOGRAPHY_COPY_DEFAULT_LIGHT};
		font-family: ${SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL.fontFamily};
		font-size: ${SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL.fontSize};
		font-stretch: ${SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL.fontStretch};
		font-weight: ${SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL.fontWeight};
		letter-spacing: ${SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL.letterSpacing};
		line-height: ${SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL.lineHeight};
		text-decoration: ${SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL.textDecoration};
		&.is-hidden {
			opacity: 0;
		}
	}
	&.is-hidden {
		grid-template-rows: 0fr;
	}

	button {
		align-items: center;
		margin-bottom: 2px;
	}
`;

export const SelectionCardStyles = styled.div<{ isDebug?: boolean; hasTechData?: boolean }>`
	position: relative;
	width: 100%;
	display: inline-flex;
	min-width: 300px;
	flex-direction: column;
	transition: all 0.1s ease-in-out;

	&::after {
		display: inline-block;
		content: ' ';
		position: absolute;
		top: 0px;
		bottom: -1px;
		left: 0px;
		right: 0px;
		border: 1px solid ${SEM_COLOR_FORMS_SURFACE_CONTROL_STROKE_DEFAULT_LIGHT};
		background: transparent;
		pointer-events: none;
	}

	&.is-selected {
		&::after {
			border: 2px solid ${SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_INTERACTIVE_LIGHT};
			z-index: 1;
		}
		&:not(:first-child)::after {
			top: -1px;
		}
		&.is-read-only::after {
			border-color: ${SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_DISABLED_LIGHT};
		}
	}

	&.is-read-only {
		&::after {
			border-color: ${SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_DISABLED_LIGHT};
		}
	}

	&:hover:not(.is-read-only)::after {
		border-color: ${SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_INTERACTIVE_LIGHT};
		z-index: 2;
	}

	.image-container {
		overflow: hidden;
		width: 100%;
		img {
			width: 100%;
			aspect-ratio: 3 / 1;
			object-fit: cover;
			object-position: 100% 0;
		}
	}

	.top-item {
		grid-area: 1 / 1;
	}

	.loading-item {
		grid-area: 1 / 1;
		height: 20px;
		width: 20px;
		z-index: ${zIndexTop};
	}

	.selection-card-content {
		padding: ${SYS_SPACE_RELATIVE_BP_MD_MD};
	}

	.selection-card-title {
		display: grid;
		grid-template-columns: 1fr;
		place-items: start;
		${({ isDebug }) => {
			if (isDebug) {
				return `
					label div:last-child {
						line-break: anywhere;
					}
				`;
			}
		}}
	}

	.selection-card-header {
		display: flex;
		flex-direction: column;
		place-items: start;
		${({ hasTechData }) => {
			if (hasTechData) {
				return `
					gap: ${SYS_SPACE_RELATIVE_BP_SM_SM};
					padding-block-end: ${SYS_SPACE_RELATIVE_BP_SM_SM};
				`;
			}
		}}
	}
	.toggle-descripton-layout {
		width: 100%;
		display: flex;
		place-items: center;
		flex-direction: row;
	}

	.spacer {
		width: 100%;
		height: ${SYS_SPACE_RELATIVE_BP_SM_SM};
	}

	.selection-card-description {
		display: flex;
		flex-direction: column;
		gap: ${SYS_SPACE_RELATIVE_BP_MD_MD};
		align-items: start;
		margin-bottom: 2px;
	}
`;
